export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35')
];

export const server_loads = [2,8];

export const dictionary = {
		"/(admin)/(dashboard)": [~9,[2]],
		"/(admin)/(global)/artificial": [10,[2]],
		"/(admin)/emc/capacity": [~14,[2,4]],
		"/(admin)/emc/imbalance": [~15,[2,4]],
		"/(admin)/emc/performance": [~16,[2,4]],
		"/(admin)/emc/vmware": [~17,[2,4]],
		"/(admin)/hp/(events)/fe-port-events": [~18,[2,5]],
		"/(admin)/hp/(global-statistics)/latency-imbalances": [~21,[2,6]],
		"/(admin)/hp/(global-statistics)/logical-capacity": [~22,[2,6]],
		"/(admin)/hp/(global-statistics)/performance": [~23,[2,6]],
		"/(admin)/hp/(events)/pg-events": [~19,[2,5]],
		"/(admin)/hp/(global-statistics)/physical-capacity": [~24,[2,6]],
		"/(admin)/hp/(events)/sla": [~20,[2,5]],
		"/(admin)/hp/(global-statistics)/throughput-imbalances": [~25,[2,6]],
		"/(admin)/hp/(global-statistics)/vmware-capacity": [~26,[2,6]],
		"/(admin)/(global)/maintainers": [~11,[2]],
		"/(admin)/netapp/aggregateCapacity": [~27,[2]],
		"/(admin)/netapp/hostExports": [28,[2]],
		"/(admin)/netapp/qtrees": [29,[2]],
		"/(admin)/netapp/qtrees/public": [30,[2]],
		"/(admin)/netapp/sharesAndSnapshots": [~31,[2]],
		"/(admin)/netapp/snapMirrorHealth": [~32,[2]],
		"/(admin)/netapp/volumeCapacity": [~33,[2]],
		"/(admin)/overview/[system]/ldev-heatmap": [~35,[2,,8],[,7]],
		"/(admin)/overview/[system]/[board]": [34,[2,,8],[,7]],
		"/(admin)/(global)/storage-config": [~12,[2,3]],
		"/(admin)/(global)/storage-config/[id]": [~13,[2,3]]
	};

export const hooks = {
	handleError: (({ kind, error }) => { if (kind === 'unknown') { console.error(error); } }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);